import { useGlobalFilters } from '../hooks/useGlobalFilters';
import { useSessionsData } from '../hooks/useSessions';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import SessionsDropDownItem from './SessionsDropDownItem';


/* Выпадающий грид-карточки выбора сессии */
 const SessionsDropDown = observer(({session_job_type}) => {
  const [showSessionDrop, setShowSessionDrop] = useState(false);
  const filtersStore = useGlobalFilters();
  const { sessions, isLoading: isSessionsLoading } = useSessionsData(false);


  const renderButtonTitle = (session_job_type, selectedSession) => {
    let session = sessions[session_job_type].find(s => String(s.session_id) === String(selectedSession));
    return (session ? <SessionsDropDownItem session={session} active={true} /> : 'Выбрать сессию');
  }
  
  console.log('sessions',sessions[session_job_type]);

  return (
    <>
      <div style={{ position: 'relative'}}>
        <button
          className="filters-bar-style__date-input__input"
          style={{ width: 580, marginRight: 8, textAlign: 'left', background: '#fff', border: '1px solid #ccc', borderRadius: 6, padding: '6px 8px' }}
          onClick={() => setShowSessionDrop(!showSessionDrop)}
          type="button"
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'left' }}>
          {renderButtonTitle(session_job_type, filtersStore.selectedSession[session_job_type])}
          <span style={{ float: 'right'}}>
            ▼
          </span>
          </div>
        </button>
        {showSessionDrop && (
          <div
            style={{
              position: 'absolute',
              top: 80,
              left: 0,
              zIndex: 20,
              width: 580,
              maxHeight: 340,
              overflowY: 'auto',
              background: '#fff',
              border: '1px solid #ccc',
              borderRadius: 8,
              boxShadow: '0 4px 16px rgba(0,0,0,0.11)',
              padding: 6
            }}
          >
            <div
              className="session-card"
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 10
              }}
            >
              <div
                style={{
                  cursor: 'pointer',
                  padding: '4px 4px',
                  borderRadius: 5,
                  border: filtersStore.selectedSession === '' ? '2px solid #229' : '1px solid #ddd',
                  background: filtersStore.selectedSession === '' ? '#e4e9fa' : '#fafafa'
                }}
                onClick={() => {
                  filtersStore.setSelectedSession('');
                  setShowSessionDrop(false);
                }}
              >
                <div style={{fontWeight: 600, fontSize: 14, marginBottom: 4}}>Все сессии</div>
              </div>
              {sessions[session_job_type].map(session => (
                <SessionsDropDownItem 
                  session={session} 
                  active={filtersStore.selectedSession[session_job_type] == session.session_id} 
                  handleClick={() => {
                    filtersStore.setSelectedSession(session_job_type, String(session.session_id));
                    setShowSessionDrop(false);
                    console.log('filtersStore.selectedSession',filtersStore.selectedSession[session_job_type]);
                }}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
});
              

export default SessionsDropDown;